import { createSlice } from "@reduxjs/toolkit";
import { AgentRegisterHandler } from "./register";

const initialState = {
  register: {},
  login: {},
};
const authSlice = createSlice({
  name: "auth",
  initialState,
  extraReducers: (builder) => {
    AgentRegisterHandler(builder);
  },
});
export default authSlice.reducer;
